import { useEffect, useState } from "react";

/**
 * Custom hook to add a delay before rendering content.
 * @param {string | undefined} delayTime - Time to delay rendering in seconds.
 * @returns {Object} - Object containing the endDelay state.
 */
export const useDelay = ({ delayTime }: { delayTime: string | undefined }) => {
    const [endDelay, setEndDelay] = useState(false);

    useEffect(() => {
        // Check if delayTime is provided
        if (delayTime) {
            const timer = setTimeout(() => {
                setEndDelay(true);
            }, +delayTime * 1000); // Converting delayTime to milliseconds

            // Cleanup function to clear the timer
            return () => clearTimeout(timer);
        } else {
            // If delayTime is not provided, end delay immediately & avoid using setTimeout
            setEndDelay(true);
        }
    }, [delayTime]);

    return {
        endDelay,
    };
};
